module.exports = __webpack_public_path__ + "static/media/pdf.a8c4eb16.svg";